import { jsx as a } from "../../_virtual/jsx-runtime.mjs";
import { createContext as m, useState as d, useMemo as C, useEffect as l, useContext as M } from "react";
import { useReoMessage as g } from "./useReoMessage.mjs";
import { rcReactRender as x } from "./lib/rcReactRender.mjs";
import { getGlobal as y } from "../../utils/getGlobal.mjs";
let o = null, f = null, c = !1, u = {};
const p = m({
  messageApi: null,
  config: {},
  setConfig: () => null
}), A = () => {
  const { config: e } = M(p), [n, s] = g(e);
  return l(() => {
    n && (o = n, c = !0);
  }, [n]), s;
}, b = () => {
  const [e, n] = d(u), s = C(() => ({
    messageApi: o,
    config: e,
    setConfig: (r) => {
      n((i) => ({ ...i, ...r }));
    }
  }), [e]);
  return l(() => {
    f = (r) => {
      n((i) => ({ ...i, ...r }));
    };
  }, []), /* @__PURE__ */ a(p.Provider, { value: s, children: /* @__PURE__ */ a(A, {}) });
}, w = () => {
  if (c)
    return;
  const e = y().document.createDocumentFragment();
  x(/* @__PURE__ */ a(b, {}), e);
}, t = {
  open: (e) => {
    if (!(typeof window > "u")) {
      if (!c) {
        w(), requestAnimationFrame(() => {
          o && o.open(e);
        });
        return;
      }
      o && o.open(e);
    }
  },
  info: (e, n) => {
    t.open({ type: "info", content: e, duration: n });
  },
  error: (e, n) => {
    t.open({ type: "error", content: e, duration: n });
  },
  warning: (e, n) => {
    t.open({ type: "warning", content: e, duration: n });
  },
  success: (e, n) => {
    t.open({ type: "success", content: e, duration: n });
  },
  config: (e) => {
    u = { ...e }, f && f(e);
  },
  useReoMessage: g
};
export {
  t as default
};
//# sourceMappingURL=ReoMessage.mjs.map
